import {AbstractProfileFormComponent} from "../../abstract/abstract-profile/abstract-profile-form.component";
import {Component, OnDestroy} from "@angular/core";
import {BFOnFormLoadComplete} from "../../../core/interfaces/sdk-profile-hooks.interface";
import {MultiLineComponent} from "@fgpp-ui/components";
import {ProfileFormTemplateProviders} from "../../../core/templates/profile-form.template.providers";
import {UserAmountLimitsComponent} from "./modals/user-amount-limits.component";

@Component({
  selector: 'app-amount-limits',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class AmountLimitsComponent extends AbstractProfileFormComponent implements OnDestroy, BFOnFormLoadComplete {

  fgppFormLoadComplete(): void {
    setTimeout(() => this.formMgr.get('DETAILS').getLayoutControl<MultiLineComponent>().setModalComponent(UserAmountLimitsComponent));
  }

}
